import React from 'react';

import Main from './Main';
import Footer from './Footer';
import './HomeView.css';

const HomeView = () => (
  <section className="home-view">
    <Main />
    <Footer />
  </section>
);

export default HomeView;



// WEBPACK FOOTER //
// ./src/views/HomeView/HomeView.js